import React from 'react';
import PropTypes from 'prop-types';

const Iframe = ({ src }) => {
  return (
    <>
      <iframe className="api-iframe" title="api-iframe" src={src}></iframe>
    </>
  );
}

export default Iframe;

Iframe.propTypes = {
  src: PropTypes.string.isRequired
};